<template>
  <div v-loading="loading">
    <el-input
      v-model="config.name"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入人员姓名">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetch"></el-button>
    </el-input>
    <el-table
      :data="list"
      height="520px"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="name"
        label="人员姓名"
        min-width="240"></el-table-column>
      <el-table-column
        prop="work"
        label="职业"
        min-width="140"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import Expert from '@/service/expert'
export default {
  name: 'ExpertInfo',
  props: {
    linkType: { type: Number, default: 230 }
  },
  data() {
    return { loading: false, list: [], total: 0, config: { name: '', pageNum: 1, pageSize: 10, status: 1 }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetch() {
      this.config.pageNum = 1
      this.fetchList()
    },
    selectitem(item) {
      this.$emit('select', { linkType: this.linkType, link: item.id, title: item.name })
    },
    fetchList() {
      this.loading = true
      Expert.getexperts({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
